<div class="modal-container">
    <div class="modal-content">
      <h1 class="modal-title">Configuration History</h1>
      
      <!-- config-history-dialog.component.html -->
            <h6>{{ customerName }} > {{ groupName }}</h6>

            <ag-grid-angular
            class="ag-theme-alpine"
            style="width: 100%; height: 300px"
            [rowData]="rowData"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            >
            </ag-grid-angular>

            <div style="margin-top: 20px; text-align: right;">
            <button 
              type="button" 
              class="btn-confirm" 
              (click)="onClose()">
              Close
            </button>
            </div>

    
    
    </div>
  </div>
  
  